import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
import FinalSalaryScheme from '@/guiide/ts/assets/finalsalary/finalSalaryScheme';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'NextStepCoaching',
  setup(__props) {

const store = useStore();

const schemeName = ref("");

onMounted(() => {
    setSchemeName();
})

watch(
    () => store.state.retiree,
    () => {
        setSchemeName();
    }
);

function setSchemeName() {
    if (!store.state.retiree) {
        return;
    }

    const schemeInfo: FinalSalaryScheme = store.state.retiree.finalSalaries.schemes[0];
    schemeName.value = schemeInfo.name;
}

function onBookCoachingClicked() {
    window.open('https://example.com', '_blank');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "fw-bold" }, "Access to one-to-one financial coaching", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, " When you're thinking about your retirement plans, it's natural to have questions about your finances and the choices available to you. One-to-one financial coaching gives you the opportunity to speak confidentially with a qualified financial professional and receive personalised guidance tailored to your situation. ", -1)),
    _createElementVNode("p", null, " As a member of the " + _toDisplayString(schemeName.value) + ", you have access to independent one-to-one financial coaching at no cost. Whether you want help understanding your retirement options, the tax implications of your pensions, or simply need reassurance as you plan for the next stage of your life, our financial coaches are here to support you. ", 1),
    _cache[2] || (_cache[2] = _createElementVNode("p", null, " To book your free coaching session, please click the link below. ", -1)),
    _createElementVNode("button", {
      class: "btn btn-secondary btn-book",
      onClick: onBookCoachingClicked
    }, "Book your free coaching session"),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mt-4 fst-italic text-muted" }, [
      _createElementVNode("small", null, [
        _createTextVNode(" Disclaimer: Please note that the one-to-one coaching service is designed to provide guidance, education, and support. It is "),
        _createElementVNode("strong", null, "NOT"),
        _createTextVNode(" a replacement for independent financial advice. ")
      ])
    ], -1)),
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "fst-italic text-muted" }, [
      _createElementVNode("small", null, " The coaches are not authorised or regulated to provide individual financial advice in the UK and cannot recommend specific financial products or actions. If you require regulated financial advice, you should seek assistance from a professional financial adviser who is authorised to offer advice tailored to your personal circumstances. ")
    ], -1))
  ], 64))
}
}

})